import React, {ReactNode} from 'react'
import { Box, Typography, Paper } from '@mui/material';
import equal from 'fast-deep-equal'

interface TimeTableViewItemTime {
    minute: number
    hour: number
}

interface TimeTableViewItemProps {
    startTime: TimeTableViewItemTime
    endTime: TimeTableViewItemTime
    children: ReactNode
    pixelPer5Minutes: number
}

const TimeTableViewItem: React.FC<TimeTableViewItemProps> = React.memo(props => {
    const {startTime, endTime, pixelPer5Minutes} = props

    if (startTime === null || endTime === null) {
        return null
    }

    const convertToMinutes = (time: TimeTableViewItemTime): number => {
        return time.hour * 60 + time.minute
    }

    const pixelPer1Minute = pixelPer5Minutes / 5

    const headSpace = (30 * pixelPer1Minute)
    const startPosition = convertToMinutes(startTime) * pixelPer1Minute
    const endPosition = convertToMinutes(endTime) * pixelPer1Minute

    return (
        <Paper
            style={{
                left: `calc(2px + 3px)`,
                top: `${headSpace + startPosition}px`,
                width: `calc(100% - 5px - 2px)`,
                height: `${endPosition - startPosition}px`,
                position: `absolute`,
                backgroundColor: 'rgba(0, 131, 138, 0.35)',
                border: '1px solid rgba(0, 131, 138, 1)',
            }}
        >
            <Box ml={'2px'} mt={'2px'}>
                <Typography variant={'caption'}>{props.children}</Typography>
            </Box>
        </Paper>
    )
}, (prevProps, nextProps) => (prevProps === nextProps || equal(prevProps, nextProps)))

TimeTableViewItem.displayName = 'TimeTableViewItem'
export default TimeTableViewItem
